<template>
  <div>
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: 0 }"
    >
      <h6 class="font-semibold mt-30 mb-10">Info</h6>
      <a-descriptions class="mb-10" title="" :column="1">
          <a-descriptions-item label="">
          <p class="mt-5 mb-5 text-muted">
            Thai ID :
            <span class="text-dark">
              {{ dataContact[0].thai_id_no }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-0 mb-0 text-muted">
            Passport :
            <span class="text-dark">
              {{ dataContact[0].passport_no }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-0 mb-0 text-muted">
            Birth Date : <span class="text-dark mr-5">
              {{ dataContact[0].date_of_birth }}
            </span> Gender :
            <span class="text-dark">
              {{ dataContact[0].gender }}
            </span>
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="">
          <p class="mt-0 mb-0 text-muted">
            Main Contact :
          </p>
          <p class="text-muted mt-5 mb-5 f-12"></p>
          <p class="text-muted mt-5 mb-10 f-12">
            <ul>
              <li>Tel : {{ dataContact[0].main_contact_detail_mobile_number }}</li>
              <li>Address : {{ dataContact[0].main_contact_detail_address }}</li>
              <li>
                  Sub District : {{ dataContact[0].main_contact_detail_sub_district }} 
              </li>
              <li>
                  District : {{ dataContact[0].main_contact_detail_district }}
              </li>
              <li>
                  Province : {{ dataContact[0].main_contact_detail_province }}
              </li>
              <li>
                  Postal Code : {{ dataContact[0].main_contact_detail_postal_code }} 
              </li>
            </ul>
          </p>
        </a-descriptions-item>
    </a-descriptions>
    </a-card>
    <h6 class="font-semibold mt-20 mb-20">Emergency</h6>
    <!-- collapse address -->
    <a-collapse accordion>
      <a-collapse-panel key="1" header="Father Contact">
        <emergencydata
          :dataemer="[
            {
              name_th:
                dataContact[0].father_english_first_name +
                ' ' +
                dataContact[0].father_english_middle_name +
                ' ' +
                dataContact[0].father_english_last_name,
              name_en:
                dataContact[0].father_native_first_name +
                ' ' +
                dataContact[0].father_native_middle_name +
                ' ' +
                dataContact[0].father_native_last_name,
              tel: dataContact[0].father_mobile_number,
              mail: dataContact[0].father_mobile_email,
              address: dataContact[0].father_address,
              SubDistrict: dataContact[0].father_sub_district,
              District: dataContact[0].father_district,
              Province: dataContact[0].father_address_province,
              Country: dataContact[0].father_address_country,
              Code: dataContact[0].father_address_postal_code,
            },
          ]"
        />
      </a-collapse-panel>
      <a-collapse-panel key="2" header="Mother Contact">
        <emergencydata
          :dataemer="[
            {
              name_th:
                dataContact[0].mother_english_first_name +
                ' ' +
                dataContact[0].mother_english_middle_name +
                ' ' +
                dataContact[0].mother_english_last_name,
              name_en:
                dataContact[0].mother_native_first_name +
                ' ' +
                dataContact[0].mother_native_middle_name +
                ' ' +
                dataContact[0].mother_native_last_name,
              tel: dataContact[0].mother_mobile_number,
              mail: dataContact[0].mother_mobile_email,
              address: dataContact[0].mother_address,
              SubDistrict: dataContact[0].mother_sub_district,
              District: dataContact[0].mother_district,
              Province: dataContact[0].mother_address_province,
              Country: dataContact[0].mother_address_country,
              Code: dataContact[0].mother_address_postal_code,
            },
          ]"
        />
      </a-collapse-panel>
      <a-collapse-panel key="3" header="Guardian Contact">
        <emergencydata
          :dataemer="[
            {
              name_th:
                dataContact[0].guardian_english_first_name +
                ' ' +
                dataContact[0].guardian_english_middle_name +
                ' ' +
                dataContact[0].guardian_english_last_name,
              name_en:
                dataContact[0].guardian_native_first_name +
                ' ' +
                dataContact[0].guardian_native_middle_name +
                ' ' +
                dataContact[0].guardian_native_last_name,
              tel: dataContact[0].guardian_mobile_number,
              mail: dataContact[0].guardian_mobile_email,
              address: dataContact[0].guardian_address,
              SubDistrict: dataContact[0].guardian_sub_district,
              District: dataContact[0].guardian_district,
              Province: dataContact[0].guardian_address_province,
              Country: dataContact[0].guardian_address_country,
              Code: dataContact[0].guardian_address_postal_code,
            },
          ]"
        />
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
import emergencydata from "./emergency.vue";
export default {
  props: {
    dataContact: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    emergencydata,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.f-18 {
  font-size: 18px;
}
.f-16 {
  font-size: 16px;
}
.f-14 {
  font-size: 14px;
}
.f-12 {
  font-size: 12px;
  font-weight: 300;
}
</style>